export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_48',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_48_usd',
			EUR: 'simple_workbook_bundle_48_eur',
			GBP: 'simple_workbook_bundle_48_gbp',
			AUD: 'simple_workbook_bundle_57_99_aud',
			CAD: 'simple_workbook_bundle_57_99_cad',
			DKK: 'simple_workbook_bundle_399_dkk',
			SEK: 'simple_workbook_bundle_499_sek',
			NOK: 'simple_workbook_bundle_459_nok',
			BRL: 'simple_workbook_bundle_169_brl',
			MXN: 'simple_workbook_bundle_799_mxn',
			TRY: 'simple_workbook_bundle_1599_try',
			ARS: 'simple_workbook_bundle_64000_ars',
			COP: 'simple_workbook_bundle_195000_cop',
			CLP: 'simple_workbook_bundle_47000_clp',
		},
		primer: 'prd_vxw4mum5vy0b',
	},
	otp: {
		priceMap: {
			USD: 48,
			EUR: 48,
			GBP: 48,
			AUD: 57.99,
			CAD: 57.99,
			DKK: 399,
			SEK: 499,
			NOK: 459,
			BRL: 169,
			MXN: 799,
			TRY: 1599,
			ARS: 64000,
			COP: 195000,
			CLP: 47000,
		},
	},
}
